// entry.client.js
import createApp from './src/app.js';

const { app, router } = createApp();

router.onReady(() => {
  updateMeta(router.currentRoute);

  router.beforeEach((to, from, next) => {
    updateMeta(to);
    next();
  });

  app.$mount('#app');
});

function updateMeta(route) {
  const meta = route.meta || {};
  const defaultTitle = 'GB WhatsApp Download v18.80 Pro APK 2026 | Real | Latest';
  const defaultDescript = 'Download the latest GB WhatsApp v18.80 Pro APK for Android in 2026. Enjoy extra privacy options, custom themes, dual Wa App accounts, and better media sharing in one app.';
  const defaultKeyword = 'gb whatsapp, gb whatsapp download, gb whatsapp apk, gb whatsapp pro';
  document.title = meta.title || defaultTitle;
  const siteOrigin = 'https://gbwhata.io';
  const defaultCanonical = `${siteOrigin}/`;
  const ogImage = `${siteOrigin}/favicon.webp`;
  const pageTitle = meta.title || defaultTitle;
  const pageDescription = meta.description || defaultDescript;

  setMetaTag('description', pageDescription);
  setMetaTag('keywords', meta.keywords || defaultKeyword);
  setMetaProperty('og:type', 'website');
  setMetaProperty('og:title', pageTitle);
  setMetaProperty('og:description', pageDescription);
  setMetaProperty('og:image', ogImage);
  const canonical = (meta.link || []).find((link) => link.rel === 'canonical');
  const canonicalHref = canonical ? canonical.href : defaultCanonical;
  setMetaProperty('og:url', canonicalHref);
  setLinkTag('canonical', canonicalHref);
  setMetaTag('twitter:card', 'summary');
  setMetaTag('twitter:image', ogImage);
  setLinkTag('icon', '/favicon.webp', 'image/webp');
  setLinkTag('icon', '/favicon.ico');
  setLinkTag('apple-touch-icon', '/favicon.webp');

  if (meta.noindex) {
    setMetaTag('robots', 'noindex');
  } else {
    // 如果不是 noindex 页面，确保 robots 标签是默认的
    setMetaTag('robots', 'index,follow');
  }
}

function setMetaTag(name, content) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}

function setMetaProperty(property, content) {
  let element = document.querySelector(`meta[property="${property}"]`);
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute('property', property);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}

function setLinkTag(rel, href, type) {
  const selector = type
    ? `link[rel="${rel}"][type="${type}"]`
    : `link[rel="${rel}"]:not([type])`;
  let element = document.querySelector(selector);
  if (element) {
    element.setAttribute('href', href);
    if (type) {
      element.setAttribute('type', type);
    }
  } else {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    element.setAttribute('href', href);
    if (type) {
      element.setAttribute('type', type);
    }
    document.head.appendChild(element);
  }
}
